<template>
  <div>
    <CartPanel @toggle="toggle" />
    <van-popup
      position="bottom"
      v-model="show"
      round
      close-on-popstate
      class="inset-x-0 z-[999999999999] mx-auto max-h-[82vh] max-w-screen-sm overflow-hidden rounded-t-2xl"
    >
      <CartList />
    </van-popup>
  </div>
</template>

<script>
import CartList from "@/components/cart/CartList";

import CartPanel from "@/components/cart/CartPanel.vue";
import { mapGetters } from "vuex";

export default {
  components: { CartList, CartPanel },
  data() {
    return {
      show: false,
      show_cart: false,
    };
  },
  methods: {
    toggle() {
      if (this.atCheckout || this.atConfirm) return false;
      const nextShow = !this.show;
      this.show = nextShow;

      if (nextShow && this.$track && this.hasItems) {
        this.$track.viewCart({
          value: this.amount,
          items: this.items,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      amount: "cart/amount",
      hasItems: "cart/hasItems",
      items: "cart/items",
    }),
    atCheckout() {
      return this.$route.name?.match("order-checkout");
    },
    atConfirm() {
      return this.$route.name?.match("order-confirm");
    },
  },
};
</script>
